"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/popconfirm/style/css");

var _popconfirm = _interopRequireDefault(require("antd/es/popconfirm"));

require("antd/es/collapse/style/css");

var _collapse = _interopRequireDefault(require("antd/es/collapse"));

var _avatar = _interopRequireDefault(require("antd/lib/avatar"));

var _button = _interopRequireDefault(require("antd/lib/button"));

var _col = _interopRequireDefault(require("antd/lib/grid/col"));

var _row = _interopRequireDefault(require("antd/lib/grid/row"));

var _switch = _interopRequireDefault(require("antd/lib/switch"));

var _lodash = _interopRequireDefault(require("lodash"));

var _moment = _interopRequireDefault(require("moment"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _Util = require("../../../../components/util/Util");

var _participants = require("../../../../redux/participants/participants.types");

var _payment = require("../../../../redux/payment/payment.types");

var selectors = _interopRequireWildcard(require("../../../../redux/selectors"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Panel
} = _collapse.default;

class ParticipantViewCard extends _react.Component {
  render() {
    var _a;

    const requestExitInterviewPayment = () => {
      const {
        participant,
        requestExitInterviewPayment
      } = this.props;
      requestExitInterviewPayment(participant.id);
    };

    const {
      participant,
      avatarBase64,
      saveParticipantActualHivStatus,
      saveParticipantInterviewSelected,
      studyArms,
      studyId,
      exitInterviewPayment,
      surveysFeatureEnabled,
      referralsFeatureEnabled,
      exitInterviewFeatureEnabled
    } = this.props;
    const avatar = avatarBase64 ? /*#__PURE__*/_react.default.createElement(_avatar.default, {
      size: 50,
      src: avatarBase64,
      style: {
        backgroundColor: participant.avatarBackground ? `#${participant.avatarBackground}` : '#FFB100'
      }
    }) : null;
    return /*#__PURE__*/_react.default.createElement(_collapse.default, {
      defaultActiveKey: ['headerPanel']
    }, /*#__PURE__*/_react.default.createElement(Panel, {
      key: "headerPanel",
      header: /*#__PURE__*/_react.default.createElement("div", {
        className: "profile",
        style: {
          display: 'inline-block'
        }
      }, /*#__PURE__*/_react.default.createElement(_row.default, {
        align: "middle",
        justify: "start",
        style: {
          minWidth: "700px"
        }
      }, /*#__PURE__*/_react.default.createElement(_col.default, {
        span: 3
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "profile-header"
      }, avatar)), /*#__PURE__*/_react.default.createElement(_col.default, {
        span: 16,
        pull: 1
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "profile-header"
      }, ' ', `${participant.firstName} ${participant.lastName ? participant.lastName : ''} (${participant.id}) `))))
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "profile"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "profile-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "demo"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Username")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.username)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Email")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.email)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Mobile")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.mobile)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label",
      style: {
        alignSelf: 'flex-start'
      }
    }, /*#__PURE__*/_react.default.createElement("label", null, "Address")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.address1 ? participant.address1 : '', /*#__PURE__*/_react.default.createElement("br", null), participant.address2 ? `${participant.address2}` : '', participant.address2 ? /*#__PURE__*/_react.default.createElement("br", null) : '', `${participant.city ? participant.city : ''}, ${participant.state ? participant.state : ''} ${participant.postalCode ? participant.postalCode : ''}`))), (surveysFeatureEnabled || referralsFeatureEnabled) && /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-section"
    }, surveysFeatureEnabled && /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Qualtrics Study Id")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.qualtricsStudyId)), referralsFeatureEnabled && /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Referred By")), participant.referredByParticipantId ? /*#__PURE__*/_react.default.createElement("a", {
      href: `/study/${studyId}/participants/${participant.referredByParticipantId}/`
    }, (_a = participant.referredByParticipant) === null || _a === void 0 ? void 0 : _a.username, ' ') : /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, "None")), referralsFeatureEnabled && /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Referrals")), participant.referredParticipants ? /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, _lodash.default.map(participant.referredParticipants, p => {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: `ref_${p.id}`
      }, /*#__PURE__*/_react.default.createElement("a", {
        href: `/study/${studyId}/participants/${p.id}/`
      }, p.username, ' '));
    })) : /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, "None"))), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-section"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Study Arm")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, (0, _Util.getStudyArmLabelFromId)(studyArms, participant.studyArmId))), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Type")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.type)), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Created Date")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, (0, _moment.default)(participant.createDate).format('MM/DD/YYYY'))), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Mobile Enrollment Date")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, (0, _moment.default)(participant.mobileEnrollmentDate).format('MM/DD/YYYY'))), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "External Id")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, participant.externalId))), /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-section"
    }, exitInterviewFeatureEnabled && /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Exit Interview?")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement(_popconfirm.default, {
      title: 'Are you sure?',
      onConfirm: () => {
        saveParticipantInterviewSelected({
          participantId: participant.id,
          interviewSelected: Boolean(!participant.interviewSelected)
        });
      }
    }, /*#__PURE__*/_react.default.createElement(_switch.default, {
      checked: participant.interviewSelected
    })))), exitInterviewFeatureEnabled && !!participant.interviewSelected && !exitInterviewPayment && /*#__PURE__*/_react.default.createElement("div", {
      className: "demo-row"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "label"
    }, /*#__PURE__*/_react.default.createElement("label", null, "Pay Incentive")), /*#__PURE__*/_react.default.createElement("div", {
      className: "field"
    }, /*#__PURE__*/_react.default.createElement(_button.default, {
      size: "small",
      onClick: requestExitInterviewPayment
    }, "Create Incentive")))))))));
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  studyArms: selectors.getStudyArms,
  studyId: selectors.getRequestedStudyId,
  exitInterviewPayment: selectors.getRequestedParticipantExitInterviewPayment,
  surveysFeatureEnabled: selectors.getSurveysFeatureEnabled,
  referralsFeatureEnabled: selectors.getReferralsFeatureEnabled,
  exitInterviewFeatureEnabled: selectors.getExitInterviewFeatureEnabled
});

const mapDispatchToProps = dispatch => {
  return {
    requestExitInterviewPayment: participantId => dispatch(_payment.requestExitInterviewPaymentAsync.request(participantId)),
    saveParticipantActualHivStatus: val => dispatch(_participants.saveParticipantActualHivStatusAsync.request(val)),
    saveParticipantInterviewSelected: val => dispatch(_participants.saveParticipantInterviewSelectedAsync.request(val))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ParticipantViewCard);

exports.default = _default;